package io.horion.cv.styles

import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

val HeadbarContainerStyle = CssStyle {
    base {
        Modifier.padding(16.px)
    }
    Breakpoint.MD {
        Modifier.padding(18.px)
    }
    Breakpoint.LG {
        Modifier.padding(20.px)
    }
}

val HeadbarBackButtonStyle = CssStyle {
    base {
        Modifier.margin(left = 10.px)
    }
    Breakpoint.MD {
        Modifier.margin(left = 30.px)
    }
    Breakpoint.LG {
        Modifier.margin(left = 95.px)
    }
}

val HeadbarIconSizeStyle = CssStyle {
    base {
        Modifier.fontSize(8.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(10.px)
    }
    Breakpoint.LG {
        Modifier.fontSize(14.px)
    }
}

val HeadbarTextSizeStyle = CssStyle {
    base {
        Modifier.fontSize(12.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(14.px)
    }
    Breakpoint.LG {
        Modifier.fontSize(16.px)
    }
}

val HeadbarTitleGroupStyle = CssStyle {
    base {
        Modifier.margin(right = 30.px)
    }
    Breakpoint.MD {
        Modifier.margin(right = 100.px)
    }
    Breakpoint.LG {
        Modifier.margin(right = 200.px)
    }
}

val HeadbarDownloadWrapperStyle = CssStyle {
    base {
        Modifier.margin(right = 20.px)
    }
    Breakpoint.MD {
        Modifier.margin(right = 80.px)
    }
}

val HeadbarThemeToggleGroupStyle = CssStyle {
    base {
        Modifier.margin(right = 10.px)
    }
    Breakpoint.MD {
        Modifier.margin(right = 30.px)
    }
    Breakpoint.LG {
        Modifier.margin(right = 95.px)
    }
}

val HeadbarThemeIconSizeStyle = CssStyle {
    base {
        Modifier.fontSize(18.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(25.px)
    }
}

val HeadbarTitleStyle = CssStyle {
    base {
        Modifier
            .fontSize(12.px)
            .fontFamily(INTER)
            .fontWeight(FontWeight.Bold)
            .cursor(Cursor.Text)
            .whiteSpace(WhiteSpace.NoWrap)
    }

    Breakpoint.MD {
        Modifier.fontSize(14.px)
    }

    Breakpoint.LG {
        Modifier.fontSize(16.px)
    }
}

val HeadbarTitleInputStyle = CssStyle {
    base {
        Modifier
            .width(120.px)
            .fontSize(12.px)
            .fontFamily(INTER)
            .fontWeight(FontWeight.Bold)
            .padding(leftRight = 6.px)
            .border(1.px, LineStyle.Solid, Colors.Placeholder)
            .borderRadius(4.px)
            .styleModifier {
                property("box-sizing", "border-box")
                property("outline", "none")
                property("background", "transparent")
                property("color", "inherit")
            }
    }

    Breakpoint.MD {
        Modifier
            .width(180.px)
            .fontSize(14.px)
    }

    Breakpoint.LG {
        Modifier
            .width(240.px)
            .fontSize(16.px)
    }
}